import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DeleteCourse from "../../../../Controllers/Admin/ClassAndCourses/DeleteCourse";
import GetAllCourses from "../../../../Controllers/Admin/ClassAndCourses/GetAllCourses";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function CoursesListingViewModel() {
  let location = useLocation();

  const [SchoolID, setSchoolID] = useState("");
  const [ClassID, setClassID] = useState("");
  const [AuthUser, setAuthUser] = useState();
  const [CoursesArray, setCoursesArray] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setClassID(LocationArray.pop());
  }, [location?.pathname]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const CoursesData = await GetAllCourses(ClassID);
      setCoursesArray(CoursesData);
      setIsLoading(false);
    }
    fetchData();
  }, [ClassID]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [CourseID, setCourseID] = useState("");

  const handleOpenDeleteDialog = (id) => {
    setCourseID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteCourse(CourseID);
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  // Course Card Dropdown Start
  const [OpenDropdown, setOpenDropdown] = useState(); // undefined is nothing open
  const toggle = (id) => setOpenDropdown(OpenDropdown === id ? undefined : id); // close if currently open
  // Course Card Dropdown End

  return [
    CoursesArray,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    ClassID,
    AuthUser,
    IsLoading,
  ];
}
